import type { UserState } from '../user-slice-reducer';

interface WithUser {
  user: UserState;
}

/**
 * @description
 * Selector used to determine if we're currently in the admin app. Useful for
 * components and utilities that are shared between apps.
 * @returns `true` if we're in the admin app, `false` otherwise.
 * @example
 * ```ts
 * import { useSelector } from 'react-redux';
 * import { userSliceSelectors } from '@highlight-cp/redux-state';
 *
 * const userId = useSelector(userSliceSelectors.id);
 * ```
 */
export const id = ({ user: state }: WithUser) => state.id;
